export default __webpack_public_path__ + "static/media/17.c48ee841.jpg";